const ChairishContext = window.chairisher.context;

/**
 * @returns {Array.<String>} A list of benefits for the trade program
 */
export default function getTradeInsuranceProgramBenefits() {
    return JSON.parse(ChairishContext.TRADE_INSURANCE_PROGRAM_BENEFITS);
}
